// Single Video content block — YouTube facade. Swaps the cover/play
// button for an autoplaying iframe on click. Markup is emitted by
// craft/templates/blocks/_singleVideo.twig.

const addAutoplay = (url) => {
    if (!url) return url
    const sep = url.includes('?') ? '&' : '?'
    const must = 'autoplay=1&mute=0&playsinline=1'
    return url.includes('autoplay=1') ? url : `${url}${sep}${must}`
}

const singleVideo = {
    init() {
        document.querySelectorAll('[data-single-video]').forEach((wrap) => {
            const trigger = wrap.querySelector('.single-video__trigger')
            const iframe = wrap.querySelector('.single-video__embed iframe')

            if (!trigger || !iframe) return

            trigger.addEventListener('click', function handler() {
                wrap.classList.add('is-playing')

                const dataSrc = iframe.getAttribute('data-src')
                iframe.src = addAutoplay(dataSrc || iframe.src)

                trigger.removeEventListener('click', handler)
            })
        })
    }
}

export default singleVideo
